import { render, staticRenderFns } from "./ServicesHeader.vue?vue&type=template&id=600cc7a7&scoped=true&"
import script from "./ServicesHeader.vue?vue&type=script&lang=js&"
export * from "./ServicesHeader.vue?vue&type=script&lang=js&"
import style0 from "./ServicesHeader.vue?vue&type=style&index=0&id=600cc7a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600cc7a7",
  null
  
)

export default component.exports